// The Secrets page's side cards: how a value is protected (docs/05 "Credential handling")
// and when each secret's value was last replaced.
import { useT } from "../i18n";
import { day } from "../pages/format";
import { WidgetCard } from "../ui/Card";
import { Mono } from "../ui/status";
import type { Credential } from "./templates";

const KEYS = ["data", "master", "sealing"] as const;

export function ProtectionCard({ className }: { className?: string }) {
  const t = useT().secrets.aside;
  return (
    <WidgetCard className={className} title={t.protection}>
      <ol className="m-0 list-none space-y-3.5 p-0">
        {KEYS.map((k, i) => (
          <li key={k} className="flex gap-3">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-lighter font-display text-[13px] font-bold text-secondary-dark">
              {i + 1}
            </span>
            <div>
              <div className="text-[13px] font-semibold text-gray-900">{t.keys[k].title}</div>
              <div className="text-xs text-gray-500">{t.keys[k].text}</div>
            </div>
          </li>
        ))}
      </ol>
      <p className="mb-0 mt-4 border-t border-muted pt-3 text-xs text-gray-500">{t.footnote}</p>
    </WidgetCard>
  );
}

export function RotationCard({ credentials, className }: { credentials: Credential[]; className?: string }) {
  const t = useT().secrets.aside;
  return (
    <WidgetCard className={className} title={t.rotation}>
      {credentials.map((c) => (
        <div key={c.id} className="flex items-center justify-between gap-3 py-1.5 text-[13px]">
          <Mono className="truncate text-gray-900">{c.name}</Mono>
          <span className="shrink-0 text-gray-500">{c.rotated_at ? t.rotated(day(c.rotated_at)) : t.added(day(c.created_at))}</span>
        </div>
      ))}
    </WidgetCard>
  );
}
